import { CustomColumnModelInterface, TableColumnsSetting } from '@/interfaces/table-setting';
import { RentalClientModel } from '@/models/rentals/rental-client-model';

export class RentalClientsTableSettings {
  public static getColumnsSetting(): TableColumnsSetting<keyof RentalClientModel> {
    return [
      this.getColumnSelectClient(),
      {
        name: 'numeroBp',
        text: 'BP',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'codiceFiscale',
        text: 'Codice Fiscale',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'piva',
        text: 'P. IVA',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'denominazione',
        text: 'Denominazione',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'dataNascita',
        text: 'Data di nascita',
        type: 'date',
        filter: {
          type: 'date',
        },
      },
      {
        name: 'luogoNascita',
        text: 'Luogo di Nascita',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'email',
        text: 'Email',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'numeroPatente',
        text: 'Nr. Patente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'numeroTelefono',
        text: 'Telefono',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'localita',
        text: 'Località',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'indirizzo',
        text: 'Indirizzo',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'consensoAssicurazione',
        text: 'Consenso Assicurazione',
        type: 'checkbox',
      },
      {
        name: 'consensoIndigSoddClientela',
        text: 'Consenso Indig Sodd Clientela',
        type: 'checkbox',
      },
      {
        name: 'consensoMarketing',
        text: 'Consenso Marketing',
        type: 'checkbox',
      },
      {
        name: 'consensoMarketingTerzeParti',
        text: 'Consenso Marketing Terze Parti',
        type: 'checkbox',
      },
      {
        name: 'consensoProfilazione',
        text: 'Consenso Profilazione',
        type: 'checkbox',
      },
    ];
  }

  private static getColumnSelectClient(): CustomColumnModelInterface {
    return {
      name: 'btnSelectClient',
      index: 0,
      customButton: true,
      unsortable: true,
      condition: function (row) {
        return true;
      },
    };
  }
}
